import { render, staticRenderFns } from "./html/AddressForm.html?vue&type=template&id=3af4f1e6&lang=html&external"
import script from "./js/AddressForm.js?vue&type=script&lang=js&external"
export * from "./js/AddressForm.js?vue&type=script&lang=js&external"
import style0 from "./scss/AddressForm.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports